// Model of the open position lines: take profit, stop loss, liquidation and their zones

export const LEVEL_KIND = {
  TAKE_PROFIT: "takeProfit",
  STOP_LOSS: "stopLoss",
  LIQUIDATION: "liquidation",
};

export const ZONE_KIND = {
  PROFIT: "profit",
  LOSS: "loss",
};

export const ZONE_TOWARDS = {
  UP: "up",
  DOWN: "down",
};
